/* eslint-disable react-hooks/exhaustive-deps */
import {
    useEffect,
} from 'react';

import { TransitionDirection } from './actions/transitions';

import useAnimations from './useAnimations';
/*
 * This hook and the animationsStore manages transitions between pages, 
 * It creates a temporary view to animate before moving the real view through the routes after the transition animation.
 * Note: This Hook manages Two View Transitions at one time.
 */

function usePageTransitions  (p) {
    const {
        elementName,
        duration: _duration = 0.2,
        viewAnimation = false,
    } = p;
    
    const {
        animationsStore: astore,
    } = useAnimations();

    useEffect(() => {
        astore.duration = _duration;
        if (viewAnimation) {
            setUpForAnimation();
        } else {
            setupAsRoutePage();
        }
    }, []);

    function setupAsRoutePage () {
        astore.setOutgoingView(elementName);
        astore.currentView = elementName;
    }

    function setUpForAnimation () {
        if (astore.direction ===  TransitionDirection.BACK) {
            astore.backView = elementName;
        } else {
            astore.nextView = elementName;
        }
    }

    function setDirection (v) {
        astore.setDirection(v);
    }

    function setTransitionsProps (p) {
        astore.setTransitionsProps(p);
    }

    function setTransitionsWithTarget (p) {
        astore.setTransitionsWithTarget(p);
    }

    function setViewRenderer (v) {
        astore.setRenderer(v);
    }
    
    return {
        setDirection,
        setTransitionsProps,
        setTransitionsWithTarget,
        setViewRenderer,
    };
}

export default usePageTransitions;
